import { API } from 'aws-amplify'

const updateEmarsysContact = async (
    email: string,
    firstName: string,
    lastName: string,
    mobile: string,
    gender: string,
    address: string,
    marketingOptIn: boolean
) => {
    await API.post(
        'clickfrenzyFeEmarsys',
        '/contact',
        {
            body: {
                email,
                gender,
                address,
                given_name: firstName,
                family_name: lastName,
                phone_number: mobile,
                'custom:marketing_opt_in': marketingOptIn,
            },
        }
    )
}

const setEmarsysWebExtend = (email?: string, command?: string, value?: any, go?: boolean) => {
    if (go) {
        (window as any).ScarabQueue.push(['go'])
    } else {
        if (command && value) {
            (window as any).ScarabQueue.push([command, value])
        } else {
            if (email) {
                (window as any).ScarabQueue.push(['setEmail', email])
            } else {
                (window as any).ScarabQueue.push(['setEmail', 'visitor@clickfreny.com.au'])
            }
        }
    }
}

export {
    updateEmarsysContact,
    setEmarsysWebExtend,
}
